import * as _ from "lodash"
import { InsuranceQuote } from "@requests"

export interface IHasBaseInsuranceQuoteObject {
    getBaseInsuranceQuoteObject(): InsuranceQuote | undefined
    setBaseInsuranceQuoteObject(baseQuoteObject: InsuranceQuote): void
}

function hasBaseInsuranceQuoteObject<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasBaseInsuranceQuoteObject {
        private baseInsuranceQuoteObject: InsuranceQuote | undefined

        constructor(...args: any[]) {
            super(...args);
        }

        public getBaseInsuranceQuoteObject(): InsuranceQuote | undefined {
            return this.baseInsuranceQuoteObject
        }
        public setBaseInsuranceQuoteObject(baseInsuranceQuoteObject: InsuranceQuote): void {
            this.baseInsuranceQuoteObject = _.cloneDeep(baseInsuranceQuoteObject)
        }
    };
}

export default hasBaseInsuranceQuoteObject